import { ColumnDefinition } from '@approvalmax/ui/src/components';

import { NetSuiteLineCustomField } from './NetSuiteLineCustomField';
import { CustomFieldsLine } from './NetSuiteLineCustomField.types';
import { GetCustomFieldsColumnDefinitionProps } from './NetSuiteLineCustomField.types';

export const getCustomFieldsColumnDefinition = (props: GetCustomFieldsColumnDefinitionProps) => {
    const { availableCustomFields, sublistType, namePrefix, workflowId, ocrIsLoading } = props;

    return availableCustomFields.map<ColumnDefinition<CustomFieldsLine>>((field) => ({
        id: field.id,
        name: field.name,
        minWidth: 150,
        verticalAlign: 'top',
        cellComponent: (props) => (
            <NetSuiteLineCustomField
                cellProps={props}
                field={field}
                sublistType={sublistType}
                fieldName={`${namePrefix || 'lines'}.${props.item.index}.customFields.${field.id}`}
                disabled={
                    !field.workflows?.some((workflow) => workflow.workflowId === workflowId && workflow.isEditable) ||
                    ocrIsLoading
                }
            />
        ),
    }));
};
